var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cartIconWrapper"},[_c('nuxt-link',{attrs:{"to":"/cart"}},[_c('HeaderIcon',{staticClass:"cartIcon",attrs:{"count":_vm.count}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }